// extracted by mini-css-extract-plugin
export var currencyInput = "_l7-1";
export var currencySymbol = "_l7-0";